<template>
  <div>
    <div class="pt-vod mb_controller_home w-100" v-if="loads">
      <div class="container-fluid mt-2">
        <div class="row mb-4 justify-content-center">
          <div
            class="col-12 col-lg-6 pr-md-1 px-0"
            ref="radioIframe"
            id="radio_iframe"
          >
            <div class="container-fluid">
              <div class="row align-items-center">
                <div class="col-12 mt-0 px-0 px-md-1">
                  <div class="w-100 d-flex align-items-start flex-column">
                    <div
                      class="w-100 h-100 mt-2 d-flex justify-content-center align-items-center p-2"
                      v-if="external_radio"
                    >
                      <iframe
                        loading="lazy"
                        :src="`${external_radio_url}`"
                        frameborder="0"
                        scrolling="no"
                        allowfullscreen="true"
                        webkitallowfullscreen="true"
                        mozallowfullscreen="true"
                        style="width: 320px; border:0;background: #000 !important;border: 1px solid #d9e021;height: 416px;"
                      ></iframe>
                    </div>
                    <div
                      class="w-100 h-100 mt-2 d-flex justify-content-center p-2"
                      v-else
                    >
                      <iframe
                        loading="lazy"
                        :src="
                          `https://rtmklik-radio-player.s3.ap-southeast-1.amazonaws.com/index.html?radio=${player_id}`
                        "
                        frameborder="0"
                        scrolling="no"
                        allowfullscreen="true"
                        webkitallowfullscreen="true"
                        mozallowfullscreen="true"
                        style="width: 100%; border:0;background: #000 !important;"
                        :height="iframeHeight"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="d-none d-md-flex col-12 col-lg-6 px-2 pl-lg-0 pt-2"
            v-if="show_epg"
          >
            <div class="w-100">
              <div class="tab w-100">
                <div class="tab-wrapper">
                  <!-- Tab 1 -->
                  <input id="tab1" type="radio" name="tabsA" checked />
                  <label class="mb-0" for="tab1">{{ todays_date }}</label>
                  <div
                    class="tab-content set-overflow"
                    :style="{ height: jadualHeight }"
                  >
                    <timelineJadualRadio
                      :data="todays_list"
                      v-if="show_todays_epg"
                    />
                    <div class="w-100" v-else>
                      <p class="no-record-title">Tiada rekod dijumpai</p>
                    </div>
                  </div>

                  <!-- Tab 2 -->
                  <input id="tab2" type="radio" name="tabsA" />
                  <label class="tab-button mb-0" for="tab2">Esok</label>
                  <div
                    class="tab-content set-overflow"
                    :style="{ height: jadualHeight }"
                  >
                    <timelineJadualRadio
                      :data="tomorrows_list"
                      v-if="show_tomorrows_epg"
                    />
                    <div class="w-100" v-else>
                      <p class="no-record-title">Tiada rekod dijumpai</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 d-flex d-md-none mt-4">
            <radioTabsMobile
              :todaysData="todays_list"
              :tomorrowsData="tomorrows_list"
              :todays_date="todays_date"
            />
          </div>
        </div>
        <div class="row mt-3 mt-md-1 d-none d-md-flex">
          <!-- <div class="col-12">
            <MaintainanceDesktop />
            <MaintainanceMobile />
          </div> -->
          <div class="col-12 ">
            <RadioNasional class="mb-3 mb-md-5" />
            <RadioNegeri class="my-3 my-md-5" />
            <RadioTempatan class="my-3 my-md-5" />
          </div>
          <div class="col-12">
            <!-- ads bottom -->
            <BillboardBannerBottom v-if="desktop"></BillboardBannerBottom>
            <MrecBannerBottom v-if="mobile"></MrecBannerBottom>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      style="min-height: 70vh; display: flex; align-items: center;justify-content: center;color: white;"
    >
      <p>loading</p>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import BreadCrumbsHeader from '@/components/common/breadCrumbsHeader.vue';
import BillboardBannerBottom from '../components/ads/radio/billboardBannerBottom';
import MrecBannerBottom from '../components/ads/radio/mrecBannerBottom';
// v1
import RadioMainCarousel from '../components/carousel/radio/v1/radioFeaturedCarousel.vue';
import RadioNasional from '../components/carousel/radio/v1/radioNasional.vue';
import RadioNegeri from '../components/carousel/radio/v1/radioNegeri.vue';
import RadioTempatan from '../components/carousel/radio/v1/radioTempatan.vue';
// json
import radioNasionalJson from '@/static/radio-nasional.json';
import radioNegeriJson from '@/static/radio-negeri.json';
import radioTempatanJson from '@/static/radio-tempatan.json';
import noimage from '../assets/noimage.png';
import timelineJadualRadio from '../components/common/timelineJadualRadio.vue';
import radioTabsMobile from '../components/common/radioTabsMobile.vue';
// maintainance
// import MaintainanceDesktop from "../components/ads/maintainance/leaderboardTop.vue";
// import MaintainanceMobile from "../components/ads/maintainance/mobileMidRec.vue";
import axios from 'axios';

export default {
  components: {
    RadioMainCarousel,
    BreadCrumbsHeader,
    BillboardBannerBottom,
    MrecBannerBottom,
    RadioNasional,
    RadioNegeri,
    RadioTempatan,
    timelineJadualRadio,
    radioTabsMobile,
    // MaintainanceDesktop,
    // MaintainanceMobile,
  },
  data: function() {
    return {
      slug: this.$route.params.id,
      id: '',
      player_id: '',
      player_title: '',
      external_radio: false,
      external_radio_url: '',
      img_url: '',
      currentid: 0,
      radio: [],
      tablet: false,
      mobile: false,
      desktop: false,
      todays_list: [],
      tomorrows_list: [],
      todays_date: '',
      tomorrows_date: '',
      show_epg: false,
      show_todays_epg: false,
      show_tomorrows_epg: false,
      img_url: '',
      loads: false,
      clientWidth: 0,
      clientHeight: 0,
      iframeHeight: 0,
      jadualHeight: 0,
      window: {
        width: window.innerWidth,
        height: 0,
      },
    };
  },
  methods: {
    getimglink(img) {
      return require(`@/assets/rtmklik/thumbnail/radio/${img}`);
    },
    getIconPath(iconName) {
      return iconName
        ? require(`../assets/rtmklik/thumbnail/radio/${iconName}`)
        : noimage;
    },
    deviceCheck() {
      if (this.$device.ipad) {
        this.tablet = true;
      } else if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },

    initializecontentview() {
      var self = this;
      var token = localStorage.getItem('token');
      $.ajax({
        type: 'POST',
        url: 'https://rtm.glueapi.io/report/viewed',
        contentType: 'application/json; charset=utf-8',
        headers: {
          'X-AUTH-TOKEN': `${token}`,
        },
        data: JSON.stringify({
          idContent: self.currentid, // Content ID from content api response
          contentTitle: self.player_title, // Content Longtitle from content api response
          site: 'RTMKlik',
          dbLogging: 1,
        }),
        dataType: 'json',
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
    initializepageview() {
      var self = this;
      $.ajax({
        type: 'POST',
        url: 'https://rtm.glueapi.io/report/page-view',
        contentType: 'application/json',
        data: JSON.stringify({
          href: self.$route.path,
          title: 'radio',
          site: 'RTMKlik',
        }),
        dataType: 'json',
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
    goTo(link) {
      this.$router.push(link);
    },
    getFirstId(obj) {
      obj.forEach((element, index) => {
        if (index == 0) {
          let url = `/radio/${this.$route.params.type}/${element.slug}`;
          this.goTo(url);
        }
      });
    },
    getPlayerDetails(obj) {
      obj.forEach((element) => {
        if (element.slug == this.$route.params.id) {
          this.player_id = element.player_id;
          this.id = element.id;
          this.player_title = element.title;
          this.img_url = element.image;

          if (element.id === 10222 || element.id === 10223) {
            this.external_radio = true;
            this.external_radio_url = element.player_id;
          }
        }
      });
    },
    pad(value) {
      return value < 10 ? '0' + value : value;
    },
    async createOffset(date) {
      var sign = date.getTimezoneOffset() > 0 ? '-' : '+';
      var offset = Math.abs(date.getTimezoneOffset());
      var hours = this.pad(Math.floor(offset / 60));
      var minutes = this.pad(offset % 60);
      return sign + hours + ':' + minutes;
    },
    async getEPGList(id, date, type) {
      let radio_id;

      if (id == 72211) {
        radio_id = 13;
      } else if (id == 72201) {
        radio_id = 14;
      } else if (id == 72221) {
        radio_id = 15;
      } else if (id == 72171) {
        radio_id = 16;
      } else if (id == 72191) {
        radio_id = 17;
      } else if (id == 72181) {
        radio_id = 18;
      } else if (id == 72261) {
        radio_id = 29;
      } else if (id == 72291) {
        radio_id = 37;
      } else if (id == 72331) {
        radio_id = 38;
      } else if (id == 72241) {
        radio_id = 28;
      } else if (id == 72321) {
        radio_id = 36;
      } else if (id == 72371) {
        radio_id = 24;
      } else if (id == 72301) {
        radio_id = 35;
      } else if (id == 72231) {
        radio_id = 33;
      } else if (id == 72281) {
        radio_id = 39;
      } else if (id == 72381) {
        radio_id = 31;
      } else if (id == 72251) {
        radio_id = 30;
      } else if (id == 72311) {
        radio_id = 32;
      } else if (id == 72341) {
        radio_id = 40;
      } else if (id == 72361) {
        radio_id = 26;
      } else if (id == 72411) {
        radio_id = 43;
      } else if (id == 72351) {
        radio_id = 25;
      } else if (id == 72401) {
        radio_id = 51;
      } else if (id == 72451) {
        radio_id = 49;
      } else if (id == 72481) {
        radio_id = 50;
      } else if (id == 72271) {
        radio_id = 27;
      } else if (id == 72501) {
        radio_id = 52;
      } else if (id == 72491) {
        radio_id = 41;
      } else if (id == 72441) {
        radio_id = 42;
      } else if (id == 72421) {
        radio_id = 44;
      } else if (id == 72431) {
        radio_id = 45;
      } else if (id == 72461) {
        radio_id = 48;
      } else if (id == 72471) {
        radio_id = 46;
      } else if (id == 72391) {
        radio_id = 47;
      } else {
        radio_id = '';
        this.show_epg = false;
      }

      // let offset = new Date().getTimezoneOffset();
      // let timezone = offset / 60;
      let timezone = this.getTimeZone();
      // const timezone = await this.createOffset(new Date());
      // console.log(offset);
      // console.log(timezone);
      // console.log(await this.createOffset(new Date()));
      if (radio_id) {
        try {
          axios
            .get(
              `https://rtm.glueapi.io/v3/epg/${radio_id}/ChannelSchedule?dateStart=${date}&dateEnd=${date}&timezone=${timezone}&embed=author%2Cprogram`
            )
            .then((response) => {
              // this.assignDetailsWithoutEps(response.data);
              if (type == 'today') {
                this.assignTodaysEPG(response.data);
              } else if (type == 'tomorrow') {
                this.assignTomorrowEPG(response.data);
              }
              return response.data;
            });
        } catch (e) {
          console.log(e);
        }
      }
    },
    assignTodaysEPG(obj) {
      this.todays_list = obj.schedule;
      if (this.todays_list.length > 0) {
        this.show_todays_epg = true;
      }
    },
    assignTomorrowEPG(obj) {
      this.tomorrows_list = obj.schedule;
      if (this.tomorrows_list.length > 0) {
        this.show_tomorrows_epg = true;
      }
    },
    initializeRadioForStart() {
      if (this.$route.params.id) {
        // set player id
        // set player title
        if (this.$route.params.type == 'tempatan') {
          this.getPlayerDetails(radioTempatanJson);
          this.show_epg = true;
          let todayDate = this.getTodaysDate('today');
          let tomorrowDate = this.getTodaysDate('tomorrow');
          this.todays_date = todayDate;
          this.getEPGList(this.id, todayDate, 'today');
          this.getEPGList(this.id, tomorrowDate, 'tomorrow');
          // this.show_epg = false;
        } else if (this.$route.params.type == 'negeri') {
          this.getPlayerDetails(radioNegeriJson);
          this.show_epg = true;
          let todayDate = this.getTodaysDate('today');
          let tomorrowDate = this.getTodaysDate('tomorrow');
          this.todays_date = todayDate;
          this.getEPGList(this.id, todayDate, 'today');
          this.getEPGList(this.id, tomorrowDate, 'tomorrow');
          // this.show_epg = false;
        } else if (this.$route.params.type == 'nasional') {
          this.getPlayerDetails(radioNasionalJson);

          if (!this.external_radio) {
            this.show_epg = true;
            let todayDate = this.getTodaysDate('today');
            let tomorrowDate = this.getTodaysDate('tomorrow');
            this.todays_date = todayDate;
            this.getEPGList(this.id, todayDate, 'today');
            this.getEPGList(this.id, tomorrowDate, 'tomorrow');
          }
        }

        this.currentid = this.id;
        this.initializecontentview();
        this.initializepageview();
      } else {
        if (this.$route.params.type == 'tempatan') {
          this.getFirstId(radioTempatanJson);
        } else if (this.$route.params.type == 'nasional') {
          this.getFirstId(radioNasionalJson);
        } else if (this.$route.params.type == 'negeri') {
          this.getFirstId(radioNegeriJson);
        }
      }
    },
    findHeight(ratio = '', width = 1) {
      const [w, h] = ratio.split(':').map(Number);
      const height = (width * h) / w;
      return Math.round(height);
    },
    handleResize() {
      var ratio = '530:582';
      var width = this.$refs.radioIframe.clientWidth;

      if (this.window.width <= '991') {
        this.iframeHeight = this.findHeight(ratio, width).toString() + 'px';
      } else {
        this.jadualHeight =
          (this.findHeight(ratio, width) - 58).toString() + 'px';
        this.iframeHeight =
          (this.findHeight(ratio, width) - 8).toString() + 'px';
      }
    },
  },
  mounted() {
    this.initializeRadioForStart();
    this.deviceCheck();
  },
  created: function() {
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
    $('#vidBox').empty();
    // peer5.destroy();
  },
  watch: {
    // whenever question changes, this function will run
    player_id(newPlayerID) {
      if (newPlayerID) {
        this.loads = !this.loads;
      }
    },
    loads(newLoad) {
      if (newLoad) {
        setTimeout(
          function() {
            this.handleResize();
          }.bind(this),
          1300
        );
      }
    },
  },
};
</script>

<style scoped>
.auto-height-radio {
  height: 340px;
}
.max-width-player {
  max-width: 1440px;
  margin: 0 auto;
}
.pt-vod {
  padding: 20px 0 0;
  min-height: 80vh;
}

.set-overflow {
  overflow-y: auto;
}
.jadual-title {
  font-family: 'HelveticaNeue-Bold';
  font-size: 16px;
  font-weight: bold;
  line-height: 1.28;
  text-align: left;
  color: #fff;
}
.next-day-title {
  font-family: 'HelveticaNeue-Bold';
  font-size: 16px;
  font-weight: bold;
  line-height: 1.19;
  text-align: left;
  color: #dae12f;
  padding-top: 2px;
}
.now-playing-wrapper {
  padding: 4px 6px;
  background: #fd0d1b;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
}
.now-playing-title {
  font-family: 'Sf-ui-bold';
  font-size: 12px;
  font-weight: bold;
  line-height: 1.17;
  text-align: left;
  color: #fff;
}
.radio-title {
  font-family: 'Sf-ui-bold';
  font-size: 25px;
  font-weight: bold;
  line-height: 0.56;
  text-align: left;
  color: #fff;
}
.fm-channel {
  font-family: 'Sf-ui-medium';
  font-size: 12px;
  font-weight: 500;
  line-height: 1.17;
  text-align: left;
  color: #fff;
}
.desc {
  font-family: 'HelveticaNeue-Medium';
  font-size: 14px;
  line-height: 1.14;
  text-align: left;
  color: #fff;
}

.episode-box {
  width: 44px;
  height: 44px;
  padding: 12px;
  border-radius: 3px;
  background-color: #23252b;
}
.episode-box.active {
  background-color: #d2d92e;
}
.episode-box.active span {
  color: #000000;
}
.episode-box span {
  font-family: 'HelveticaNeue-Bold';
  font-size: 18px;
  font-weight: bold;
  line-height: 1.28;
  text-align: center;
  color: #fff;
}

.epg-title {
  font-family: 'HelveticaNeue-Bold';
  font-size: 12px;
  font-weight: 300;
  line-height: 1.21;
  text-align: left;
  color: #fff;
}
.epg-desc {
  font-family: 'HelveticaNeue-Bold';
  font-size: 12px;
  font-weight: 300;
  line-height: 1.21;
  text-align: left;
  color: rgb(137, 136, 136);
}
.no-record-title {
  font-family: 'HelveticaNeue-Bold';
  font-size: 14px;
  font-weight: 500;
  line-height: 1.21;
  text-align: left;
  color: #fff;
}
.player-wrapper {
  width: 100%;
  height: 70px;
  color: white;
  background: blue;
}
.top-10-title {
  font-family: 'HelveticaNeue-Bold';
  font-size: 24px;
  font-weight: bold;
  line-height: 1.21;
  text-align: left;
  color: #fff;
}
.top-1-wrapper {
  padding: 20px;
  background-color: #1d1f25;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.order-text {
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  font-family: 'HelveticaNeue-Bold';
  font-size: 14px;
  font-weight: bold;
  line-height: 1.21;
  text-align: left;
  color: #dae12f;
  margin-right: 4px;
}
.order-title {
  font-family: 'HelveticaNeue-Bold';
  font-size: 14px;
  font-weight: 500;
  line-height: 1.21;
  text-align: left;
  color: #fff;
}
.item_img {
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  padding-top: 56.25%;
  z-index: 20;
}
.item_img .img-class {
  background: 100%;
  width: 100%;
  height: auto;
  overflow: hidden;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
}

@media screen and (max-width: 992px) {
  .set-overflow {
    height: auto;
  }
  .auto-height-radio {
    height: auto;
  }
  .pt-vod {
    padding: 10px 0 0;
  }
}
@media screen and (max-width: 768px) {
}

@media only screen and (max-width: 480px) {
  .mb_controller {
    margin-bottom: 30px;
  }
}

/* tabs */
.tab {
  --tab-padding: 16px;
  --tab-bg: #000;
  --tab-active-bg: #171f26;
}
.tab input {
  display: none;
}
.tab input:checked + label {
  background-color: var(--tab-active-bg);
  background-color: var(--tab-active-bg);
  border-radius: 8px 8px 0px 0px;
  color: #d9e021;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.tab input:not(:checked) + label + * {
  display: none;
}
.tab label {
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  cursor: pointer;
  padding: var(--tab-padding);
}
@media (max-width: 575px) {
  .tab label {
    width: 100%;
  }
}
.tab-wrapper {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  background-color: var(--tab-bg);
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1),
    0px 4px 6px -2px rgba(0, 0, 0, 0.05);
}
.tab-content {
  width: 100%;
  padding: var(--tab-padding);
  background-color: var(--tab-active-bg);
}
@media (min-width: 576px) {
  .tab-content {
    order: 9999;
  }
}
</style>
